export default {"src":"/_next/static/media/phone-icon.d8a2bf95.svg","height":42,"width":31};